
  import { defineComponent, reactive, ref } from 'vue'
  import AdminMainTopLine from '@/components/AdminMainTopLine.vue'
  import LineChart from '@/components/LineChart.vue'
  import { api } from '@/api'
  import AdminAdaptiveMainTopLine from '@/components/AdminAdaptiveMainTopLine.vue'
  import router from '@/router'

  export default defineComponent({
    components: {
      AdminMainTopLine,
      LineChart,
      AdminAdaptiveMainTopLine
    },
    setup() {
      let timer
      const faq = ref([])
      let changeactive = ref(false)
      let changeactive1 = ref(false)
      let qid = ref('')
      const data = reactive({
        title: '',
        content: '',
        word: ''
      })
      let linkPage = ref([])
      getFaq()
      async function getFaq() {
        try {
          const response = await api.get('/v1/admin/FAQ')
          faq.value = response.data.data.pages.data
          linkPage.value = response.data.data.pages.links
          linkPage.value[0].label = '&#11160;'
          linkPage.value[linkPage.value.length - 1].label = '&#11162;'
        } catch (error) {
          console.error(error)
        }
      }
      async function removeFaqById(id) {
        try {
          const response = await api.delete('/v1/admin/FAQ/delete/' + id)
          faq.value = faq.value.filter((a) => a.id !== id)
          changeactive.value = !changeactive.value
        } catch (error) {
          console.error(error)
        }
      }
      async function changeFaqById(id) {
        await router.push({
          name: 'PanelAdminFAQChange',
          params: {
            FAQId: id,
            FAQTitle: data.title,
            FAQContent: data.content
          }
        })
      }
      function endAndStartTimer() {
        window.clearTimeout(timer)
        timer = window.setTimeout(function () {
          searchArticles()
        }, 300)
      }
      async function searchArticles() {
        try {
          const response = await api.post('/v1/admin/FAQ/search', {
            word: data.word
          })
          faq.value = response.data.data.pages.data
        } catch (error) {}
      }
      async function pageLink(url) {
        try {
          const response = await api.get(url)
          faq.value = response.data.data.pages.data
          linkPage.value = response.data.data.articles.links
          linkPage.value[0].label = '&#11160;'
          linkPage.value[linkPage.value.length - 1].label = '&#11162;'
        } catch (error) {
          console.error(error)
        }
      }
      return {
        faq,
        removeFaqById,
        changeactive,
        changeactive1,
        qid,
        changeFaqById,
        data,
        endAndStartTimer,
        linkPage,
        pageLink
      }
    }
  })
